// InterviewBot.jsx - FINAL WORKING VERSION
import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Typography,
  Chip,
  LinearProgress,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,DialogContentText,
  DialogActions,
  FormControlLabel,Checkbox,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import {
  Mic,
  VolumeUp,
  Chat,
  PlayArrow,
  Pause,
  SmartToy,
  Schedule
} from '@mui/icons-material';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:5000';

const InterviewBot = ({ interview, onComplete, onClose }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [transcript, setTranscript] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [isPaused, setIsPaused] = useState(false);
  const [isCancelled, setIsCancelled] = useState(false);
  const [error, setError] = useState(null);
  const [socket, setSocket] = useState(null);
  const [responseTimeLimit, setResponseTimeLimit] = useState(10);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [noAnswerCount, setNoAnswerCount] = useState(0);
  const [showResponseTimer, setShowResponseTimer] = useState(false);

// const [instructionSeen, setInstructionSeen] = useState(false);
// const [showInstructionDialog, setShowInstructionDialog] = useState(false);

  const synthesisRef = useRef(null);
  const recognitionRef = useRef(null);
  const transcriptRef = useRef([]);
  const timerRef = useRef(null);

  const timeLimitOptions = [
    { value: 10, label: '10 seconds' },
    { value: 15, label: '15 seconds' },
    { value: 30, label: '30 seconds' },
    { value: 45, label: '45 seconds' },
    { value: 60, label: '1 minute' },
    { value: 90, label: '1.5 minutes' },
    { value: 120, label: '2 minutes' }
  ];

// useEffect(() => {
//   if (showInstructions && !instructionSeen) {
//     setShowInstructionDialog(true);
//   }
// }, [showInstructions, instructionSeen]);


  // === REPEAT DETECTION ===
  const isRepeatRequest = (text) => {
    const t = text.toLowerCase().trim();
    const patterns = [
      /repeat.*question/, /say.*again/, /can you repeat/, /could you repeat/,
      /please repeat/, /say that again/, /repeat that/, /didn't hear/,
      /can't hear/, /speak again/, /one more time/, /once more/,
      /again please/, /repeat please/, /what was that/, /what did you say/,
      /can you say that/, /could you say that/
    ];
    return patterns.some(p => p.test(t));
  };

  // === INITIALIZE INTERVIEW ===
  // useEffect(() => {
  //   const initializeInterview = async () => {
  //     try {
  //       const token = localStorage.getItem("token");
  //       if (!token) {
  //         alert("No authentication token found. Please log in.");
  //         return;
  //       }
  //       const payload = JSON.parse(atob(token.split('.')[1]));
  //       const company_id = payload.company_id;

  //       const response = await fetch(`${API_URL}/api/interviews/start-session`, {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json', },
  //         body: JSON.stringify({
  //           interviewId: interview.interviewId,
  //           mode: 'ai',
  //           positionApplied: interview.positionApplied,
  //           skills: interview.skills,
  //           experience: interview.experience,
  //           round: interview.round,
  //         })
  //       });

  //       const data = await response.json();
  //       if (data.success) {
  //         setQuestions(data.questions);
  //       } else {
  //         throw new Error('Failed to initialize interview');
  //       }

  //       const ws = new WebSocket(`${WS_URL}/interview-stream`);
  //       ws.onopen = () => {
  //         ws.send(JSON.stringify({
  //           type: 'start',
  //           interviewId: interview.interviewId,
  //           mode: 'ai'
  //         }));
  //       };
  //       setSocket(ws); 
  //     } catch (error) {
  //       console.error('Error initializing AI interview:', error);
  //       setQuestions([    
  //         "Can you tell me about yourself and your background?",
  //         "What interests you about this position?",
  //         "What are your greatest strengths?",
  //         "Can you describe a challenging project you worked on?",
  //         "How do you handle tight deadlines?",
  //         "Where do you see yourself in 5 years?",
  //         "Do you have any questions for me?"
  //       ]);
  //     }
  //   };

  //   initializeInterview();

  //   return () => {
  //     if (socket) socket.close();
  //     if (timerRef.current) clearInterval(timerRef.current);
  //     stopListening();
  //     setIsCancelled(true);
  //   };
  // }, [interview]);

  useEffect(() => {
  const initializeInterview = async () => {
    try {
      // ✅ CHECK IF QUESTIONS ALREADY PROVIDED
      if (interview.preloadedQuestions && interview.preloadedQuestions.length > 0) {
        setQuestions(interview.preloadedQuestions);
        
        // Still initialize WebSocket
        const ws = new WebSocket(`${WS_URL}/interview-stream`);
        ws.onopen = () => {
          ws.send(JSON.stringify({
            type: 'start',
            interviewId: interview.interviewId,
            mode: 'ai'
          }));
        };
        setSocket(ws);
        return; // ← SKIP API CALL
      }

      // ❌ ONLY CALL API IF NO PRELOADED QUESTIONS
      const token = localStorage.getItem("token");
      if (!token) {
        alert("No authentication token found. Please log in.");
        return;
      }
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;

      const response = await fetch(`${API_URL}/api/interviews/start-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
         },
        body: JSON.stringify({
          interviewId: interview.interviewId,
          mode: 'ai',
          positionApplied: interview.positionApplied,
          skills: interview.skills,
          experience: interview.experience,
          round: interview.round,
        })
      });

      const data = await response.json();
      if (data.success) {
        setQuestions(data.questions);
      } else {
        if (data.code === "AI_PLAN_UPGRADE_REQUIRED") {
          alert(`🔒 Plan Upgrade Required:\n\n${data.message || "AI features are not included in your current plan. Please upgrade to unlock AI."}`);
          window.dispatchEvent(new CustomEvent("openUpgradeModal", { detail: { feature: "AI Interview" } }));
          if (onClose) onClose();
          return;
        } else if (data.code === "AI_TOKENS_EXHAUSTED") {
          alert(`⚠️ AI Tokens Exhausted:\n\n${data.message || "You have used all your AI tokens for this billing cycle. Please purchase a token top-up pack."}`);
          if (onClose) onClose();
          return;
        } else {
          alert(data.message || 'Failed to initialize interview');
          if (onClose) onClose();
          return;
        }
      }

      const ws = new WebSocket(`${WS_URL}/interview-stream`);
      ws.onopen = () => {
        ws.send(JSON.stringify({
          type: 'start',
          interviewId: interview.interviewId,
          mode: 'ai'
        }));
      };
      setSocket(ws);
    } catch (error) {
      //console.error('Error initializing AI interview:', error);
      setQuestions([
        "Can you tell me about yourself and your background?",
        "What interests you about this position?",
        "What are your greatest strengths?",
        "Can you describe a challenging project you worked on?",
        "How do you handle tight deadlines?",
        "Where do you see yourself in 5 years?",
        "Do you have any questions for me?"
      ]);
    }
  };

  initializeInterview();

  return () => {
    if (socket) socket.close();
    if (timerRef.current) clearInterval(timerRef.current);
    stopListening();
    setIsCancelled(true);
  };
}, [interview]);

  // === SPEAK TEXT ===
  const speakText = (text) => {
    return new Promise((resolve, reject) => {
      if (!window.speechSynthesis) {
        reject(new Error('Speech synthesis not supported'));
        return;
      }
      window.speechSynthesis.cancel();
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.rate = 0.9;
      utterance.pitch = 1;
      utterance.volume = 1;

      utterance.onstart = () => {
        setIsSpeaking(true);
        setIsListening(false);
        setShowResponseTimer(false);
        setError(null);
      };
      utterance.onend = () => {
        setIsSpeaking(false);
        resolve();
      };
      utterance.onerror = () => {
        setIsSpeaking(false);
        reject(new Error('Speech failed'));
      };

      synthesisRef.current = utterance;
      window.speechSynthesis.speak(utterance);
    });
  };

  // === TIMER UI ===
  const startResponseCountdown = (duration) => {
    setTimeRemaining(duration);
    setShowResponseTimer(true);
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimeRemaining(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          setShowResponseTimer(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const stopCountdown = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
    setTimeRemaining(null);
    setShowResponseTimer(false);
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      try { recognitionRef.current.stop(); } catch (e) {}
      recognitionRef.current = null;
    }
    stopCountdown();
    setIsListening(false);
  };

  // === LISTENING: FIXED FOR LONG ANSWERS & REPEAT ===
  const startListening = () => {
    return new Promise((resolve, reject) => {
      if (!('SpeechRecognition' in window) && !('webkitSpeechRecognition' in window)) {
        reject(new Error('Speech recognition not supported'));
        return;
      }

      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      const rec = new SpeechRecognition();

      rec.continuous = false;
      rec.interimResults = true;
      rec.lang = 'en-US';

      let timeoutId = null;
      let hasFinal = false;
      let startedSpeaking = false;

      rec.onstart = () => {
        setIsListening(true);
        startResponseCountdown(responseTimeLimit);

        timeoutId = setTimeout(() => {
          rec.stop();
          if (!hasFinal && !startedSpeaking) {
            setNoAnswerCount(p => p + 1);
            resolve('');
          }
        }, responseTimeLimit * 1000);
      };

      rec.onresult = (ev) => {
        let interim = '';
        let final = '';
        let hasAnySpeech = false;

        for (let i = ev.resultIndex; i < ev.results.length; i++) {
          const r = ev.results[i];
          if (r.isFinal) {
            final += r[0].transcript;
            hasFinal = true;
            hasAnySpeech = true;
          } else {
            interim += r[0].transcript;
            if (r[0].transcript.trim()) hasAnySpeech = true;
          }
        }

        const spoken = (final || interim).trim();

        // === REPEAT REQUEST ===
        if (isRepeatRequest(spoken)) {
          clearTimeout(timeoutId);
          stopCountdown();
          setIsListening(false);
          setTimeout(() => { rec.stop(); resolve('REPEAT_QUESTION'); }, 100);
          return;
        }

        // === CANCEL TIMER ON ANY SPEECH ===
        if (!startedSpeaking && hasAnySpeech) {
          startedSpeaking = true;
          clearTimeout(timeoutId);
          stopCountdown();
          setShowResponseTimer(false);
        }

        // === FINAL ANSWER ===
        if (hasFinal && spoken) {
          clearTimeout(timeoutId);
          stopCountdown();
          setIsListening(false);
          setNoAnswerCount(0);
          setTimeout(() => { rec.stop(); resolve(spoken); }, 100);
        }
      };

      rec.onend = () => {
        clearTimeout(timeoutId);
        setIsListening(false);
        stopCountdown();

        if (!hasFinal && !startedSpeaking) {
          setNoAnswerCount(p => p + 1);
          resolve('');
        }
      };

      rec.onerror = (e) => {
        clearTimeout(timeoutId);
        stopCountdown();
        setIsListening(false);
        if (e.error === 'not-allowed') reject(new Error('Mic permission denied'));
      };

      recognitionRef.current = rec;
      rec.start();
    });
  };

  // === SAVE TRANSCRIPT ===
  const saveTranscriptEntry = async (entry) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;
      const payload = JSON.parse(atob(token.split('.')[1]));
      const company_id = payload.company_id;

      await fetch(`${API_URL}/api/interviews/save-transcript`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
         },
        body: JSON.stringify({ interviewId: interview.interviewId, entries: [entry] })
      });

      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(
          entry.role === 'bot'
            ? { type: 'ai_question_asked', question: entry.text, questionIndex: currentQuestionIndex }
            : { type: 'ai_answer_received', answer: entry.text, questionIndex: currentQuestionIndex }
        ));
      }
    } catch (error) {
      //console.error('Save error:', error);
    }
  };

  // === CANCEL INTERVIEW ===
  const handleCancel = () => {
    setIsCancelled(true);
    setIsPaused(true);
    window.speechSynthesis.cancel();
    stopListening();
    if (socket) socket.close();

    const entry = { role: 'system', text: '[Interview cancelled by user]', timestamp: new Date().toISOString() };
    transcriptRef.current = [...transcriptRef.current, entry];
    setTranscript(transcriptRef.current);
    saveTranscriptEntry(entry);
    onClose();
  };

  // === RESUME ===
  const handleResumeInterview = () => {
    if (noAnswerCount >= 3) setNoAnswerCount(0);
    setIsPaused(false);
    setError(null);
    const entry = { role: 'system', text: '[Interview resumed]', timestamp: new Date().toISOString() };
    transcriptRef.current = [...transcriptRef.current, entry];
    setTranscript(transcriptRef.current);
    saveTranscriptEntry(entry);
    conductInterview();
  };

  // === MAIN INTERVIEW FLOW (FIXED WITH DO-WHILE) ===
  const conductInterview = async () => {
    if (isPaused || isCancelled) return;

    for (let i = currentQuestionIndex; i < questions.length; i++) {
      if (isPaused || isCancelled) break;

      const question = questions[i];
      let shouldRepeatQuestion = false;

      do {
        shouldRepeatQuestion = false;

        if (noAnswerCount >= 3) {
          const entry = { role: 'system', text: `[Paused: No response to 3 questions]`, timestamp: new Date().toISOString() };
          transcriptRef.current = [...transcriptRef.current, entry];
          setTranscript(transcriptRef.current);
          await saveTranscriptEntry(entry);
          setError(`Paused: No response to 3 questions. Resume when ready.`);
          setIsPaused(true);
          break;
        }

        if (!shouldRepeatQuestion) {
          const qEntry = { role: 'bot', text: question, timestamp: new Date().toISOString() };
          transcriptRef.current = [...transcriptRef.current, qEntry];
          setTranscript(transcriptRef.current);
          await saveTranscriptEntry(qEntry);
        }

        try { await speakText(question); } catch (e) { setError('Speech failed'); }

        let answer = '';
        try {
          answer = await startListening();

          if (answer === 'REPEAT_QUESTION') {
            shouldRepeatQuestion = true;
            const repeatEntry = { role: 'candidate', text: '[Requested to repeat the question]', timestamp: new Date().toISOString() };
            transcriptRef.current = [...transcriptRef.current, repeatEntry];
            setTranscript(transcriptRef.current);
            await saveTranscriptEntry(repeatEntry);

            const systemEntry = { role: 'system', text: '[Repeating the question]', timestamp: new Date().toISOString() };
            transcriptRef.current = [...transcriptRef.current, systemEntry];
            setTranscript(transcriptRef.current);
            await saveTranscriptEntry(systemEntry);

            continue;
          }

          if (!answer.trim()) {
            const noAns = { role: 'system', text: `[No response in ${responseTimeLimit}s]`, timestamp: new Date().toISOString() };
            transcriptRef.current = [...transcriptRef.current, noAns];
            setTranscript(transcriptRef.current);
            await saveTranscriptEntry(noAns);
            await new Promise(r => setTimeout(r, 1000));
          } else {
            setNoAnswerCount(0);
          }
        } catch (e) {
          answer = '[Audio failed]';
        }

        if (answer.trim() && answer !== '[Audio failed]' && answer !== 'REPEAT_QUESTION') {
          const ansEntry = { role: 'candidate', text: answer, timestamp: new Date().toISOString() };
          transcriptRef.current = [...transcriptRef.current, ansEntry];
          setTranscript(transcriptRef.current);
          await saveTranscriptEntry(ansEntry);
        }
      } while (shouldRepeatQuestion);

      if (!shouldRepeatQuestion && !isPaused) {
        setCurrentQuestionIndex(i + 1);
      } else if (shouldRepeatQuestion) {
        break;
      }
    }

    if (!isPaused && !isCancelled && currentQuestionIndex >= questions.length) {
      await completeInterview();
    }
  };

  const completeInterview = async () => {
    await speakText("Thank you. The interview is complete.");
    const final = transcriptRef.current.map(e =>
      `${e.role === 'bot' ? 'Interviewer' : e.role === 'candidate' ? 'Candidate' : 'System'}: ${e.text}`
    ).join('\n\n');

    try {
      const token = localStorage.getItem("token");
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]));
        await fetch(`${API_URL}/api/interviews/complete-interview/${interview.interviewId}?company_id=${payload.company_id}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
            Authorization:`Bearer ${token}`
           },
          body: JSON.stringify({ finalTranscript: final, noAnswerCount })
        });
      }
    } catch (e) {
       //console.error(e); 
      }

    onComplete(final);
  };

  const toggleInterview = () => {
    if (isPaused) handleResumeInterview();
    else {
      setIsPaused(true);
      window.speechSynthesis.cancel();
      stopListening();
      const entry = { role: 'system', text: '[Manually paused]', timestamp: new Date().toISOString() };
      transcriptRef.current = [...transcriptRef.current, entry];
      setTranscript(transcriptRef.current);
      saveTranscriptEntry(entry);
    }
  };

  useEffect(() => {
    if (questions.length > 0 && currentQuestionIndex === 0 && !isPaused && !isCancelled) {
      conductInterview();
    }
  }, [questions.length, currentQuestionIndex, isPaused, isCancelled,]);

  const renderTranscriptEntry = (entry, i) => {
    const isBot = entry.role === 'bot';
    const isSystem = entry.role === 'system';
    return (
      <Box key={i} sx={{ mb: 2, textAlign: isBot ? 'left' : isSystem ? 'center' : 'right' }}>
        <Chip
          label={isBot ? 'Interviewer' : isSystem ? 'System' : 'Candidate'}
          color={isBot ? 'primary' : isSystem ? 'default' : 'secondary'}
          size="small"
          sx={{ mb: 0.5 }}
        />
        <Typography
          sx={{
            p: 1.5,
            borderRadius: 2,
            backgroundColor: isBot ? '#f5f5f5' : isSystem ? '#fff3cd' : '#e8f5e8',
            display: 'inline-block',
            maxWidth: '80%',
            textAlign: 'left',
            fontStyle: isSystem ? 'italic' : 'normal'
          }}
        >
          {entry.text}
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block">
          {new Date(entry.timestamp).toLocaleTimeString()}
        </Typography>
      </Box>
    );
  };

  return (
    <Dialog open={true} onClose={handleCancel} maxWidth="md" fullWidth>
     {/* {showInstructionDialog && (
      <Dialog open={showInstructionDialog} maxWidth="sm" fullWidth>
        <DialogTitle>Interview Instructions</DialogTitle>
        <DialogContent dividers>
          <DialogContentText component="div">
            <ol>
              <li>
                <strong>No background disturbance.</strong> Find a quiet place, close other apps, and turn off notifications.
              </li>
              <li>
                <strong>10-second rule.</strong> After the bot finishes reading a question you have <strong>exactly 10 seconds</strong> to start speaking. If you don’t, the bot will automatically move to the next question.
              </li>
              <li>
                <strong>Finish → next.</strong> When you stop talking the bot will wait a moment and then read the next question.
              </li>
              <li>
                <strong>Repeat request.</strong> Say <em>“repeat the question”</em> (or similar) and the bot will read the current question again.
              </li>
            </ol>
          </DialogContentText>

          <FormControlLabel
            control={
              <Checkbox
                checked={instructionSeen}
                onChange={e => setInstructionSeen(e.target.checked)}
                color="primary"
              />
            }
            label="I have read and understood all the instructions."
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="success"
            disabled={!instructionSeen}
            onClick={() => {
              setShowInstructionDialog(false);
              conductInterview(); // Start interview after agreeing
            }}
          >
            Start AI Interview
          </Button>
        </DialogActions>
      </Dialog>
    )} */}
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <SmartToy sx={{ mr: 1 }} />
            AI Interview with {interview.name}
            <Chip
              icon={isSpeaking ? <VolumeUp /> : isListening ? <Mic /> : <Chat />}
              label={isSpeaking ? "Speaking..." : isListening ? "Listening..." : isPaused ? "Paused" : "Ready"}
              color={isSpeaking ? "primary" : isListening ? "secondary" : isPaused ? "warning" : "default"}
              sx={{ ml: 2 }}
            />
          </Box>
          {!isListening && !isSpeaking && (
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel>Time Limit</InputLabel>
              <Select
                value={responseTimeLimit}
                label="Time Limit"
                onChange={(e) => setResponseTimeLimit(e.target.value)}
                disabled={isSpeaking || isListening}
              >
                {timeLimitOptions.map(o => (
                  <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Box>
      </DialogTitle>

      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}

        {showResponseTimer && timeRemaining !== null && (
          <Alert severity={timeRemaining <= 10 ? "warning" : "info"} sx={{ mb: 2 }} icon={<Schedule />}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography>Time to <strong>start</strong> answering:</Typography>
              <Typography variant="h6" fontWeight="bold">{timeRemaining}s</Typography>
            </Box>
            {noAnswerCount > 0 && (
              <Typography variant="caption" display="block">
                No response count: {noAnswerCount}
              </Typography>
            )}
          </Alert>
        )}

        {questions[currentQuestionIndex] && (
          <Paper sx={{ p: 2, mb: 2, backgroundColor: '#e3f2fd' }}>
            <Typography variant="h6">Current Question:</Typography>
            <Typography variant="body1" sx={{ mt: 1, fontWeight: 'medium' }}>
              {questions[currentQuestionIndex]}
            </Typography>
          </Paper>
        )}

        <Typography variant="h6" gutterBottom>Live Transcript:</Typography>
        <Paper variant="outlined" sx={{ p: 2, maxHeight: 300, overflow: 'auto', backgroundColor: '#fafafa' }}>
          {transcript.length === 0 ? (
            <Typography color="text.secondary" fontStyle="italic">
              Transcript will appear here...
            </Typography>
          ) : (
            transcript.map(renderTranscriptEntry)
          )}
        </Paper>

        <Box sx={{ mt: 3 }}>
          <LinearProgress
            variant="determinate"
            value={questions.length > 0 ? (currentQuestionIndex / questions.length) * 100 : 0}
            sx={{ height: 8, borderRadius: 4 }}
          />
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
            {currentQuestionIndex} of {questions.length} questions
            {isPaused && ' • PAUSED'}
            {noAnswerCount > 0 && ` • ${noAnswerCount} no-response(s)`}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          startIcon={isPaused ? <PlayArrow /> : <Pause />}
          onClick={toggleInterview}
          variant="outlined"
          color={isPaused ? "success" : "warning"}
          disabled={currentQuestionIndex >= questions.length || isCancelled}
        >
          {isPaused ? 'Resume' : 'Pause'}
        </Button>

        <Button onClick={handleCancel} variant="outlined" color="error">
          Cancel Interview
        </Button>

        {currentQuestionIndex >= questions.length && !isCancelled && (
          <Button onClick={completeInterview} variant="contained" color="success">
            Complete Interview
          </Button>
        )}
      </DialogActions>

    </Dialog>
  );
};

export default InterviewBot;